module.exports = __webpack_public_path__ + "img/OpenPosition.c8b45bc2.jpg";